// import React, { useState } from "react";

// const ManageSubPanel = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     mobile_no: "",
//     password: "",
//     address: "",
//     role: "",
//   });

//   const handleSubmit = async () => {
//     if (!form.name || !form.mobile_no || !form.password || !form.role) {
//       alert("All fields required");
//       return;
//     }

//     await fetch("https://api.d2associates.in/daso//users", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(form),
//     });

//     alert("User Added");

//     setForm({
//       name: "",
//       email: "",
//       mobile_no: "",
//       password: "",
//       address: "",
//       role: "",
//     });
//   };

//   return (
//     <div
//       style={{
//         padding: "20px",
//         background: "#f5f7fb",
//         minHeight: "100vh",
//         display: "flex",
//         justifyContent: "center",   
//       }}
//     >
//       <div style={{ width: "100%", maxWidth: "500px" }}>
        
//         <h2 style={{ marginBottom: "15px" }}>Manage Sub Panel</h2>

//         <div
//           style={{
//             background: "#fff",
//             padding: "20px",
//             borderRadius: "10px",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.08)", 
//           }}
//         >
//           {/* NAME */}
//           <input
//             placeholder="Name"
//             value={form.name}
//             onChange={(e) => setForm({ ...form, name: e.target.value })}
//             style={input}
//           />

//           {/* EMAIL */}
//           <input
//             placeholder="Email"
//             value={form.email}
//             onChange={(e) => setForm({ ...form, email: e.target.value })}
//             style={input}
//           />

//           {/* MOBILE */}
//           <input
//             placeholder="Mobile Number"
//             value={form.mobile_no}
//             onChange={(e) => setForm({ ...form, mobile_no: e.target.value })}
//             style={input}
//           />

//           {/* PASSWORD */}
//           <input
//             type="password"
//             placeholder="Password"
//             value={form.password}
//             onChange={(e) => setForm({ ...form, password: e.target.value })}
//             style={input}
//           />

//           {/* ADDRESS */}
//           <input
//             placeholder="Address"
//             value={form.address}
//             onChange={(e) => setForm({ ...form, address: e.target.value })}
//             style={input}
//           />

//           {/* ROLE */}
//           <select
//             value={form.role}
//             onChange={(e) => setForm({ ...form, role: e.target.value })}
//             style={input}
//           >
//             <option value="">Select Role</option>
//             <option value="sitemaster">Site Master</option>
//             <option value="reviewer">Reviewer</option>
//           </select>

//           {/* BUTTON */}
//           <button onClick={handleSubmit} style={btn}>
//             Submit
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "8px 18px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
//   width: "150px",         
//   marginTop: "10px",
// };

// export default ManageSubPanel;

// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     mobile_no: "",
//     password: "",
//     address: "",
//     role: "",
//   });

//   useEffect(() => {
//  fetch("https://api.d2associates.in/daso//get_staff")
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("STAFF DATA:", data);
//         setProjects(Array.isArray(data) ? data : []);
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   const filtered = Array.isArray(projects)
//     ? projects.filter((p) =>
//         ((p.name || p.NAME || "").toLowerCase()).includes(search.toLowerCase())
//       )
//     : [];

//   const handleSubmit = async () => {
//     if (
//       !form.name ||
//       !form.email ||
//       !form.mobile_no ||
//       !form.password ||
//       !form.address ||
//       !form.role
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       if (editId) {
//         await fetch(`https://api.d2associates.in/daso//update_staff/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });

//         alert("Staff Updated Successfully");
//       } else {
//         await fetch("https://api.d2associates.in/daso//add_staff", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });

//         alert("Staff Added");
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         name: "",
//         email: "",
//         mobile_no: "",
//         password: "",
//         address: "",
//         role: "",
//       });

//   fetch("https://api.d2associates.in/daso//get_staff")
//         .then((res) => res.json())
//         .then((data) => setProjects(Array.isArray(data) ? data : []));
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Staff
//       </h2>

//       <div style={container}>
//         <div style={topBar}>
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={searchInput}
//           />

//           <button
//             style={addBtn}
//             onClick={() => {
//               setShowForm(true);
//               setEditId(null);
//               setForm({
//                 name: "",
//                 email: "",
//                 mobile_no: "",
//                 password: "",
//                 address: "",
//                 role: "",
//               });
//             }}
//           >
//             + Add Staff
//           </button>
//         </div>

//         <div style={{ overflowX: "auto" }}>
//           <table style={table}>
//             <thead>
//               <tr style={{ background: "#e8edff" }}>
//                 {["#", "Name", "Email", "Mobile", "Role", "Address", "Actions"].map((h, i) => (
//                   <th key={i} style={th}>{h}</th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id || p.ID} style={tr}>
//                   <td style={td}>{i + 1}</td>

                
//                 <td>{p.name ?? p.NAME ?? "-"}</td>
// <td>{p.email ?? p.EMAIL ?? "-"}</td>
// <td>{p.mobile_no ?? p.MOBILE_NO ?? "-"}</td>
// <td>{p.role ?? p.ROLE ?? "-"}</td>
// <td>{p.address ?? p.ADDRESS ?? "-"}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div
//                         style={editBtn}
//                         onClick={() => {
//                           setForm({
//                             name: p.name || p.NAME || "",
//                             email: p.email || p.EMAIL || "",
//                             mobile_no: p.mobile_no || p.MOBILE_NO || "",
//                             password: "",
//                             address: p.address || p.ADDRESS || "",
//                             role: p.role || p.ROLE || "",
//                           });

//                           setEditId(p.id || p.ID);
//                           setShowForm(true);
//                         }}
//                       >
//                         <GrEdit size={20} />
//                       </div>

//                       <div
//                         style={deleteBtn}
//                         onClick={async () => {
//                           if (!window.confirm("Delete this staff?")) return;

//                           try {
//                             await fetch(
//                               `https://api.d2associates.in/daso//delete_staff/${p.id || p.ID}`,
//                               { method: "DELETE" }
//                             );

//                             alert("Staff Deleted");

//                        fetch("https://api.d2associates.in/daso//get_staff")
//                               .then((res) => res.json())
//                               .then((data) => setProjects(Array.isArray(data) ? data : []));

//                           } catch (err) {
//                             console.log(err);
//                           }
//                         }}
//                       >
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>{editId ? "Edit Staff" : "Add Staff"}</h3>

//             <input placeholder="Name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} style={input}/>
//             <input placeholder="Email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} style={input}/>
//             <input placeholder="Mobile" value={form.mobile_no} onChange={(e)=>setForm({...form,mobile_no:e.target.value})} style={input}/>
//             <input placeholder="Password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})} style={input}/>
//             <input placeholder="Address" value={form.address} onChange={(e)=>setForm({...form,address:e.target.value})} style={input}/>

//             <select value={form.role} onChange={(e)=>setForm({...form,role:e.target.value})} style={input}>
//               <option value="">Select Role</option>
//               <option value="sitemaster">Site Master</option>
//               <option value="reviewer">Reviewer</option>
//             </select>

//             <div style={{ display: "flex", gap: "10px" }}>
//               <button style={btn} onClick={handleSubmit}>Submit</button>
//               <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;

// /* SAME STYLES */

// /* SAME STYLES */

// const container = { background:"#fff", borderRadius:"10px", padding:"15px", boxShadow:"0 2px 8px rgba(0,0,0,0.05)" };
// const topBar = { display:"flex", justifyContent:"space-between", marginBottom:"15px", flexWrap:"wrap", gap:"10px" };
// const searchInput = { padding:"8px 12px", borderRadius:"6px", border:"1px solid #ddd", width:"100%", maxWidth:"250px" };
// const addBtn = { background:"#4a6cf7", color:"#fff", border:"none", padding:"8px 15px", borderRadius:"6px", cursor:"pointer", width:"100%", maxWidth:"150px" };
// const table = { width:"100%", borderCollapse:"collapse", minWidth:"600px" };
// const th = { textAlign:"left", padding:"12px", fontSize:"14px", color:"#555" };
// const tr = { borderBottom:"1px solid #eee" };
// const td = { padding:"10px", fontSize:"13px" };
// const editBtn = { padding:"6px", borderRadius:"6px", background:"#eef2ff", cursor:"pointer" };
// const deleteBtn = { padding:"6px", borderRadius:"6px", background:"#ffecec", cursor:"pointer", color:"#dc3545" };
// const overlay = { position:"fixed", top:0, left:0, width:"100%", height:"100%", background:"rgba(0,0,0,0.4)", display:"flex", justifyContent:"center", alignItems:"center" };
// const modal = { background:"#fff", padding:"20px", borderRadius:"10px", width:"100%", maxWidth:"400px" };
// const input = { width:"100%", padding:"10px", marginBottom:"10px", border:"1px solid #ddd", borderRadius:"6px" };
// const btn = { background:"#4a6cf7", color:"#fff", padding:"8px 15px", border:"none", borderRadius:"6px", cursor:"pointer" };
// const cancelBtn = { background:"#ccc", border:"none", padding:"8px 15px", borderRadius:"6px", cursor:"pointer" };


// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     mobile_no: "",
//     password: "",
//     address: "",
//     role: "",
//   });

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/get_staff")
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("STAFF DATA:", data);
//         setProjects(Array.isArray(data) ? data : []);
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   const filtered = Array.isArray(projects)
//     ? projects.filter((p) =>
//         ((p.name || p.NAME || "").toLowerCase()).includes(search.toLowerCase())
//       )
//     : [];

//   const handleSubmit = async () => {
//     if (
//       !form.name ||
//       !form.email ||
//       !form.mobile_no ||
//       !form.password ||
//       !form.address ||
//       !form.role
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       if (editId) {
//         await fetch(`https://api.d2associates.in/daso//api/update_staff/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });

//         alert("Staff Updated Successfully");
//       } else {
//         await fetch("https://api.d2associates.in/daso//api/add_staff", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });

//         alert("Staff Added");
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         name: "",
//         email: "",
//         mobile_no: "",
//         password: "",
//         address: "",
//         role: "",
//       });

//       fetch("https://api.d2associates.in/daso//api/get_staff")
//         .then((res) => res.json())
//         .then((data) => setProjects(Array.isArray(data) ? data : []));
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Staff
//       </h2>

//       <div style={container}>
//         <div style={topBar}>
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={searchInput}
//           />

//           <button
//             style={addBtn}
//             onClick={() => {
//               setShowForm(true);
//               setEditId(null);
//               setForm({
//                 name: "",
//                 email: "",
//                 mobile_no: "",
//                 password: "",
//                 address: "",
//                 role: "",
//               });
//             }}
//           >
//             + Add Staff
//           </button>
//         </div>


//         <div style={tableWrapper}>
//           <table style={table}>
//             <thead>
//               <tr style={{ background: "#e8edff" }}>
//                 {["#", "Name", "Email", "Mobile", "Role", "Address", "Actions"].map((h, i) => (
//                   <th key={i} style={th}>{h}</th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id || p.ID} style={tr}>
//                   <td style={td}>{i + 1}</td>

//                   <td style={td}>{p.name ?? p.NAME ?? "-"}</td>
//                   <td style={td}>{p.email ?? p.EMAIL ?? "-"}</td>
//                   <td style={td}>{p.mobile_no ?? p.MOBILE_NO ?? "-"}</td>
//                   <td style={td}>{p.role ?? p.ROLE ?? "-"}</td>
//                   <td style={td}>{p.address ?? p.ADDRESS ?? "-"}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div
//                         style={editBtn}
//                         onClick={() => {
//                           setForm({
//                             name: p.name || p.NAME || "",
//                             email: p.email || p.EMAIL || "",
//                             mobile_no: p.mobile_no || p.MOBILE_NO || "",
//                             password: "",
//                             address: p.address || p.ADDRESS || "",
//                             role: p.role || p.ROLE || "",
//                           });

//                           setEditId(p.id || p.ID);
//                           setShowForm(true);
//                         }}
//                       >
//                         <GrEdit size={20} />
//                       </div>

//                       <div
//                         style={deleteBtn}
//                         onClick={async () => {
//                           if (!window.confirm("Delete this staff?")) return;

//                           try {
//                             await fetch(
//                               `https://api.d2associates.in/daso//api/delete_staff/${p.id || p.ID}`,
//                               { method: "DELETE" }
//                             );

//                             alert("Staff Deleted");

//                             fetch("https://api.d2associates.in/daso//api/get_staff")
//                               .then((res) => res.json())
//                               .then((data) => setProjects(Array.isArray(data) ? data : []));
//                           } catch (err) {
//                             console.log(err);
//                           }
//                         }}
//                       >
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>{editId ? "Edit Staff" : "Add Staff"}</h3>

//             <input style={input} placeholder="Name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})}/>
//             <input style={input} placeholder="Email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})}/>
//             <input style={input} placeholder="Mobile" value={form.mobile_no} onChange={(e)=>setForm({...form,mobile_no:e.target.value})}/>
//             <input style={input} placeholder="Password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})}/>
//             <input style={input} placeholder="Address" value={form.address} onChange={(e)=>setForm({...form,address:e.target.value})}/>

//             <select style={input} value={form.role} onChange={(e)=>setForm({...form,role:e.target.value})}>
//               <option value="">Select Role</option>
//               <option value="sitemaster">Site Master</option>
//               <option value="reviewer">Reviewer</option>
//             </select>

//             <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//               <button style={btn} onClick={handleSubmit}>Submit</button>
//               <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;



// const container = {
//   background: "#fff",
//   borderRadius: "10px",
//   padding: "15px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   width: "100%",
// };

// const topBar = {
//   display: "flex",
//   justifyContent: "space-between",
//   marginBottom: "15px",
//   flexWrap: "wrap",
//   gap: "10px",
// };

// const searchInput = {
//   padding: "8px 12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
//   flex: "1",
//   minWidth: "180px",
// };

// const addBtn = {
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
//   width: "100%",
//   maxWidth: "160px",
// };

// const tableWrapper = {
//   width: "100%",
//   overflowX: "auto",
// };

// const table = {
//   width: "100%",
//   borderCollapse: "collapse",
//   minWidth: "650px",
// };

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
//   whiteSpace: "nowrap",
// };

// const tr = {
//   borderBottom: "1px solid #eee",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
//   whiteSpace: "nowrap",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "90%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "8px 15px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ccc",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// const Manageprojects = () => {
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     mobile_no: "",
//     password: "",
//     address: "",
//     role: "",
//   });

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//api/get_staff")
//       .then((res) => res.json())
//       .then((data) => {
//         setProjects(Array.isArray(data) ? data : []);
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   const filtered = Array.isArray(projects)
//     ? projects.filter((p) =>
//         ((p.name || p.NAME || "").toLowerCase()).includes(search.toLowerCase())
//       )
//     : [];

//   const handleSubmit = async () => {
//     if (
//       !form.name ||
//       !form.email ||
//       !form.mobile_no ||
//       !form.password ||
//       !form.address ||
//       !form.role
//     ) {
//       alert("All fields required");
//       return;
//     }

//     try {
//       if (editId) {
//         await fetch(`https://api.d2associates.in/daso//api/update_staff/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });

//         alert("Staff Updated Successfully");
//       } else {
//         await fetch("https://api.d2associates.in/daso//api/add_staff", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });

//         alert("Staff Added");
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         name: "",
//         email: "",
//         mobile_no: "",
//         password: "",
//         address: "",
//         role: "",
//       });

//       fetch("https://api.d2associates.in/daso//api/get_staff")
//         .then((res) => res.json())
//         .then((data) => setProjects(Array.isArray(data) ? data : []));
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   return (
//     <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//       <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//         Manage Staff
//       </h2>

//       <div style={container}>
//         <div style={topBar}>
//           <input
//             type="text"
//             placeholder="Search..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             style={searchInput}
//           />

//           <button
//             style={addBtn}
//             onClick={() => {
//               setShowForm(true);
//               setEditId(null);
//               setForm({
//                 name: "",
//                 email: "",
//                 mobile_no: "",
//                 password: "",
//                 address: "",
//                 role: "",
//               });
//             }}
//           >
//             + Add Staff
//           </button>
//         </div>

//         <div style={tableWrapper}>
//           <table style={table}>
//             <thead>
//               <tr style={{ background: "#D4C2BB" }}>
//                 {["#", "Name", "Email", "Mobile", "Role", "Address", "Actions"].map((h, i) => (
//                   <th key={i} style={th}>{h}</th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {filtered.map((p, i) => (
//                 <tr key={p.id || p.ID} style={tr}>
//                   <td style={td}>{i + 1}</td>

            
//                   <td style={td}>
//                     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                       <div style={avatar}>
//                         {(p.name || p.NAME || "?")[0].toUpperCase()}
//                       </div>
//                       <span>{p.name ?? p.NAME ?? "-"}</span>
//                     </div>
//                   </td>

//                   <td style={td}>{p.email ?? p.EMAIL ?? "-"}</td>
//                   <td style={td}>{p.mobile_no ?? p.MOBILE_NO ?? "-"}</td>
//                   <td style={td}>{p.role ?? p.ROLE ?? "-"}</td>
//                   <td style={td}>{p.address ?? p.ADDRESS ?? "-"}</td>

//                   <td style={td}>
//                     <div style={{ display: "flex", gap: "10px" }}>
//                       <div
//                         style={editBtn}
//                         onClick={() => {
//                           setForm({
//                             name: p.name || p.NAME || "",
//                             email: p.email || p.EMAIL || "",
//                             mobile_no: p.mobile_no || p.MOBILE_NO || "",
//                             password: "",
//                             address: p.address || p.ADDRESS || "",
//                             role: p.role || p.ROLE || "",
//                           });

//                           setEditId(p.id || p.ID);
//                           setShowForm(true);
//                         }}
//                       >
//                         <GrEdit size={20} />
//                       </div>

//                       <div
//                         style={deleteBtn}
//                         onClick={async () => {
//                           if (!window.confirm("Delete this staff?")) return;

//                           try {
//                             await fetch(
//                               `https://api.d2associates.in/daso//api/delete_staff/${p.id || p.ID}`,
//                               { method: "DELETE" }
//                             );

//                             alert("Staff Deleted");

//                             fetch("https://api.d2associates.in/daso//api/get_staff")
//                               .then((res) => res.json())
//                               .then((data) => setProjects(Array.isArray(data) ? data : []));
//                           } catch (err) {
//                             console.log(err);
//                           }
//                         }}
//                       >
//                         <RiDeleteBin5Line size={20} />
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {showForm && (
//         <div style={overlay}>
//           <div style={modal}>
//             <h3>{editId ? "Edit Staff" : "Add Staff"}</h3>

//             <input style={input} placeholder="Name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})}/>
//             <input style={input} placeholder="Email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})}/>
//             <input style={input} placeholder="Mobile" value={form.mobile_no} onChange={(e)=>setForm({...form,mobile_no:e.target.value})}/>
//             <input style={input} placeholder="Password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})}/>
//             <input style={input} placeholder="Address" value={form.address} onChange={(e)=>setForm({...form,address:e.target.value})}/>

//             <select style={input} value={form.role} onChange={(e)=>setForm({...form,role:e.target.value})}>
//               <option value="">Select Role</option>
//               <option value="sitemaster">Site Master</option>
//               <option value="reviewer">Reviewer</option>
//             </select>

//             <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//               <button style={btn} onClick={handleSubmit}>Submit</button>
//               <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Manageprojects;


// const container = {
//   background: "#fff",
//   borderRadius: "10px",
//   padding: "15px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   width: "100%",
// };

// const topBar = {
//   display: "flex",
//   justifyContent: "space-between",
//   marginBottom: "15px",
//   flexWrap: "wrap",
//   gap: "10px",
// };

// const searchInput = {
//   padding: "8px 12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
//   flex: "1",
//   minWidth: "180px",
// };

// const addBtn = {
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
//   width: "100%",
//   maxWidth: "160px",
// };

// const tableWrapper = {
//   width: "100%",
//   overflowX: "auto",
// };

// const table = {
//   width: "100%",
//   borderCollapse: "collapse",
//   minWidth: "650px",
// };

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
// };

// const tr = {
//   borderBottom: "1px solid #eee",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "90%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#4a6cf7",
//   color: "#fff",
//   padding: "8px 15px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ccc",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };


// const avatar = {
//   width: "30px",
//   height: "30px",
//   borderRadius: "50%",
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontWeight: "bold",
// };

// import React, { useState, useEffect } from "react";
// import { GrEdit } from "react-icons/gr";
// import { RiDeleteBin5Line } from "react-icons/ri";

// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const Manageprojects = () => {
//   const [projects, setProjects] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [hoveredRow, setHoveredRow] = useState(null);


//   const [showDelete, setShowDelete] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);

//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     mobile_no: "",
//     password: "",
//     address: "",
//     role: "",
//   });

//   useEffect(() => {
//     fetch("https://api.d2associates.in/daso//get_staff")
//       .then((res) => res.json())
//       .then((data) => {
//         setProjects(Array.isArray(data) ? data : []);
//       })
//       .catch((err) => console.log(err));
//   }, []);

//   const filtered = Array.isArray(projects)
//     ? projects.filter((p) =>
//         ((p.name || p.NAME || "").toLowerCase()).includes(search.toLowerCase())
//       )
//     : [];

//   const handleSubmit = async () => {
//     if (
//       !form.name ||
//       !form.email ||
//       !form.mobile_no ||
//       !form.password ||
//       !form.address ||
//       !form.role
//     ) {
//       toast.error("All fields required");
//       return;
//     }

//     try {
//       if (editId) {
//         await fetch(`https://api.d2associates.in/daso//update_staff/${editId}`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });

//         toast.success("Staff Updated Successfully");
//       } else {
//         await fetch("https://api.d2associates.in/daso//add_staff", {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         });

//         toast.success("Staff Added Successfully");
//       }

//       setShowForm(false);
//       setEditId(null);

//       setForm({
//         name: "",
//         email: "",
//         mobile_no: "",
//         password: "",
//         address: "",
//         role: "",
//       });

//       fetch("https://api.d2associates.in/daso//get_staff")
//         .then((res) => res.json())
//         .then((data) => setProjects(Array.isArray(data) ? data : []));
//     } catch (err) {
//       toast.error("Something went wrong");
//     }
//   };

  
//   const confirmDelete = async () => {
//     await fetch(`https://api.d2associates.in/daso//delete_staff/${deleteId}`, {
//       method: "DELETE",
//     });

//     toast.success("Staff Deleted Successfully");

//     setShowDelete(false);
//     setDeleteId(null);

//     fetch("https://api.d2associates.in/daso//get_staff")
//       .then((res) => res.json())
//       .then((data) => setProjects(Array.isArray(data) ? data : []));
//   };

//   return (
//     <>
//       <ToastContainer position="top-center" autoClose={2000} />

//       <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
//         <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
//           Manage Staff
//         </h2>

//         <div style={container}>
//           <div style={topBar}>
//             <input
//               type="text"
//               placeholder="Search..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               style={searchInput}
//             />

//             <button
//               style={addBtn}
//               onClick={() => {
//                 setShowForm(true);
//                 setEditId(null);
//                 setForm({
//                   name: "",
//                   email: "",
//                   mobile_no: "",
//                   password: "",
//                   address: "",
//                   role: "",
//                 });
//               }}
//             >
//               + Add Staff
//             </button>
//           </div>

//           <div style={tableWrapper}>
//             <table style={table}>
//               <thead>
//                 <tr style={{ background: "#D4C2BB" }}>
//                   {["#", "Name", "Email", "Mobile", "Password", "Role", "Address", "Actions"].map((h, i) => (
//                     <th key={i} style={th}>{h}</th>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {filtered.map((p, i) => (
//                   <tr
//                     key={p.id || p.ID}
//                     onMouseEnter={() => setHoveredRow(p.id || p.ID)}
//                     onMouseLeave={() => setHoveredRow(null)}
//                     style={{
//                       ...tr,
//                       backgroundColor:
//                         hoveredRow === (p.id || p.ID) ? "#D4C2BB" : "#fff",
//                     }}
//                   >
//                     <td style={td}>{i + 1}</td>

//                     <td style={td}>
//                       <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                         <div style={avatar}>
//                           {(p.name || p.NAME || "?")[0].toUpperCase()}
//                         </div>
//                         <span>{p.name ?? p.NAME ?? "-"}</span>
//                       </div>
//                     </td>

//                    <td style={td}>{p.email ?? p.EMAIL ?? "-"}</td>
// <td style={td}>{p.mobile_no ?? p.MOBILE_NO ?? "-"}</td>

// {/* ✅ PASSWORD */}
// <td style={td}>{p.password ?? p.PASSWORD ?? "-"}</td>

// {/* ✅ ROLE */}
// <td style={td}>{p.role ?? p.ROLE ?? "-"}</td>

// {/* ✅ ADDRESS */}
// <td style={td}>{p.address ?? p.ADDRESS ?? "-"}</td>
//                     <td style={td}>
//                       <div style={{ display: "flex", gap: "10px" }}>
//                         <div
//                           style={editBtn}
//                           onClick={() => {
//                             setForm({
//                               name: p.name || p.NAME || "",
//                               email: p.email || p.EMAIL || "",
//                               mobile_no: p.mobile_no || p.MOBILE_NO || "",
//                               password: "",
//                               address: p.address || p.ADDRESS || "",
//                               role: p.role || p.ROLE || "",
//                             });

//                             setEditId(p.id || p.ID);
//                             setShowForm(true);
//                           }}
//                         >
//                           <GrEdit size={20} />
//                         </div>

//                         {/* ✅ DELETE CLICK */}
//                         <div
//                           style={deleteBtn}
//                           onClick={() => {
//                             setDeleteId(p.id || p.ID);
//                             setShowDelete(true);
//                           }}
//                         >
//                           <RiDeleteBin5Line size={20} />
//                         </div>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {showForm && (
//           <div style={overlay}>
//             <div style={modal}>
//               <h3>{editId ? "Edit Staff" : "Add Staff"}</h3>

//               <input style={input} placeholder="Name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})}/>
//               <input style={input} placeholder="Email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})}/>
//               <input style={input} placeholder="Mobile" value={form.mobile_no} onChange={(e)=>setForm({...form,mobile_no:e.target.value})}/>
//               <input style={input} placeholder="Password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})}/>
//               <input style={input} placeholder="Address" value={form.address} onChange={(e)=>setForm({...form,address:e.target.value})}/>

//               <select style={input} value={form.role} onChange={(e)=>setForm({...form,role:e.target.value})}>
//                 <option value="">Select Role</option>
//                 <option value="sitemaster">Site Master</option>
//                 <option value="reviewer">Reviewer</option>
//               </select>

//               <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//                 <button style={btn} onClick={handleSubmit}>Submit</button>
//                 <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ✅ DELETE MODAL */}
//         {showDelete && (
//           <div style={overlay}>
//             <div style={modal}>
//               <h3>Confirm Delete</h3>
//               <p>Are you sure you want to delete this staff?</p>

//               <div style={{ display: "flex", gap: "10px" }}>
//                 <button style={btn} onClick={confirmDelete}>
//                   Yes Delete
//                 </button>

//                 <button
//                   style={cancelBtn}
//                   onClick={() => {
//                     setShowDelete(false);
//                     setDeleteId(null);
//                   }}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default Manageprojects;

// /* styles same as your file */

// const container = {
//   background: "#fff",
//   borderRadius: "10px",
//   padding: "15px",
//   boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//   width: "100%",
// };

// const topBar = {
//   display: "flex",
//   flexWrap: "wrap",         
//   justifyContent: "space-between",
//   alignItems: "center",
//   gap: "10px",
//   marginBottom: "15px",
// };

// const searchInput = {
//   padding: "8px 12px",
//   borderRadius: "6px",
//   border: "1px solid #ddd",
//   flex: "1",
//   minWidth: "120px",   
// };

// const addBtn = {
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
//   whiteSpace: "nowrap",   
// };

// const tableWrapper = {
//   width: "100%",
//   overflowX: "auto",
// };

// const table = {
//   width: "100%",
//   borderCollapse: "collapse",
//   minWidth: "650px",
// };

// const th = {
//   textAlign: "left",
//   padding: "12px",
//   fontSize: "14px",
//   color: "#555",
// };

// const tr = {
//   borderBottom: "1px solid #eee",
// };

// const td = {
//   padding: "10px",
//   fontSize: "13px",
// };

// const editBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#eef2ff",
//   cursor: "pointer",
// };

// const deleteBtn = {
//   padding: "6px",
//   borderRadius: "6px",
//   background: "#ffecec",
//   cursor: "pointer",
//   color: "#dc3545",
// };

// const overlay = {
//   position: "fixed",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0,0,0,0.4)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
// };

// const modal = {
//   background: "#fff",
//   padding: "20px",
//   borderRadius: "10px",
//   width: "90%",
//   maxWidth: "400px",
// };

// const input = {
//   width: "100%",
//   padding: "10px",
//   marginBottom: "10px",
//   border: "1px solid #ddd",
//   borderRadius: "6px",
// };

// const btn = {
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   padding: "8px 15px",
//   border: "none",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const cancelBtn = {
//   background: "#ccc",
//   border: "none",
//   padding: "8px 15px",
//   borderRadius: "6px",
//   cursor: "pointer",
// };

// const avatar = {
//   width: "30px",
//   height: "30px",
//   borderRadius: "50%",
//   background: "#D4C2BB",
//   color: "#7D4B3C",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontWeight: "bold",
// };

import React, { useState, useEffect } from "react";
import { GrEdit } from "react-icons/gr";
import { RiDeleteBin5Line } from "react-icons/ri";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Manageprojects = () => {
  const [projects, setProjects] = useState([]);
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);


  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile_no: "",
    password: "",
    address: "",
    role: "",
  });

  useEffect(() => {
    fetch("https://api.d2associates.in/get_staff")
      .then((res) => res.json())
      .then((data) => {
        setProjects(Array.isArray(data) ? data : []);
      })
      .catch((err) => console.log(err));
  }, []);

  const filtered = Array.isArray(projects)
    ? projects.filter((p) =>
        ((p.name || p.NAME || "").toLowerCase()).includes(search.toLowerCase())
      )
    : [];

  const handleSubmit = async () => {
    if (
      !form.name ||
      !form.email ||
      !form.mobile_no ||
      !form.password ||
      !form.address ||
      !form.role
    ) {
      toast.error("All fields required");
      return;
    }

    try {
      if (editId) {
        await fetch(`https://api.d2associates.in/update_staff/${editId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });

        toast.success("Staff Updated Successfully");
      } else {
        await fetch("https://api.d2associates.in/add_staff", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });

        toast.success("Staff Added Successfully");
      }

      setShowForm(false);
      setEditId(null);

      setForm({
        name: "",
        email: "",
        mobile_no: "",
        password: "",
        address: "",
        role: "",
      });

      fetch("https://api.d2associates.in/get_staff")
        .then((res) => res.json())
        .then((data) => setProjects(Array.isArray(data) ? data : []));
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  
  // const confirmDelete = async () => {
  //   await fetch(`https://api.d2associates.in/delete_staff/${deleteId}`, {
  //     method: "DELETE",
  //   });

  //   toast.success("Staff Deleted Successfully");

  //   setShowDelete(false);
  //   setDeleteId(null);

  //   fetch("https://api.d2associates.in/get_staff")
  //     .then((res) => res.json())
  //     .then((data) => setProjects(Array.isArray(data) ? data : []));
  // };
  const confirmDelete = async () => {
  try {
    const response = await fetch(
      `https://api.d2associates.in/delete_staff/${deleteId}`,
      {
        method: "DELETE",
      }
    );

    const data = await response.json();

    if (!response.ok) {
      toast.error(data.error || data.message || "Unable to delete staff");
      return;
    }

    toast.success(data.message || "Staff Deleted Successfully");

    setShowDelete(false);
    setDeleteId(null);

    fetch("https://api.d2associates.in/get_staff")
      .then((res) => res.json())
      .then((data) => setProjects(Array.isArray(data) ? data : []));
  } catch (err) {
    toast.error("Server Error");
    console.log(err);
  }
};

  return (
    <>
      <ToastContainer position="top-center" autoClose={2000} />

      <div style={{ padding: "20px", background: "#f5f7fb", minHeight: "100vh" }}>
        <h2 style={{ marginBottom: "10px", color: "#333", fontWeight: "600" }}>
          Manage Staff
        </h2>

        <div style={container}>
          <div style={topBar}>
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={searchInput}
            />

            <button
              style={addBtn}
              onClick={() => {
                setShowForm(true);
                setEditId(null);
                setForm({
                  name: "",
                  email: "",
                  mobile_no: "",
                  password: "",
                  address: "",
                  role: "",
                });
              }}
            >
              + Add Staff
            </button>
          </div>

          <div style={tableWrapper}>
            <table style={table}>
              <thead>
                <tr style={{ background: "#D4C2BB" }}>
                  {["#", "Name", "Email", "Mobile", "Password", "Role", "Address", "Actions"].map((h, i) => (
                    <th key={i} style={th}>{h}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filtered.map((p, i) => (
                  <tr
                    key={p.id || p.ID}
                    onMouseEnter={() => setHoveredRow(p.id || p.ID)}
                    onMouseLeave={() => setHoveredRow(null)}
                    style={{
                      ...tr,
                      backgroundColor:
                        hoveredRow === (p.id || p.ID) ? "#D4C2BB" : "#fff",
                    }}
                  >
                    <td style={td}>{i + 1}</td>

                    <td style={td}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <div style={avatar}>
                          {(p.name || p.NAME || "?")[0].toUpperCase()}
                        </div>
                        <span>{p.name ?? p.NAME ?? "-"}</span>
                      </div>
                    </td>

                   <td style={td}>{p.email ?? p.EMAIL ?? "-"}</td>
<td style={td}>{p.mobile_no ?? p.MOBILE_NO ?? "-"}</td>


<td style={td}>{p.password ?? p.PASSWORD ?? "-"}</td>


<td style={td}>{p.role ?? p.ROLE ?? "-"}</td>


<td style={td}>{p.address ?? p.ADDRESS ?? "-"}</td>
                    <td style={td}>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <div
                          style={editBtn}
                          onClick={() => {
                            setForm({
                              name: p.name || p.NAME || "",
                              email: p.email || p.EMAIL || "",
                              mobile_no: p.mobile_no || p.MOBILE_NO || "",
                              password: "",
                              address: p.address || p.ADDRESS || "",
                              role: p.role || p.ROLE || "",
                            });

                            setEditId(p.id || p.ID);
                            setShowForm(true);
                          }}
                        >
                          <GrEdit size={20} />
                        </div>

                
                        <div
                          style={deleteBtn}
                          onClick={() => {
                            setDeleteId(p.id || p.ID);
                            setShowDelete(true);
                          }}
                        >
                          <RiDeleteBin5Line size={20} />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {showForm && (
          <div style={overlay}>
            <div style={modal}>
              <h3>{editId ? "Edit Staff" : "Add Staff"}</h3>

              <input style={input} placeholder="Name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})}/>
              <input style={input} placeholder="Email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})}/>
              <input style={input} placeholder="Mobile" value={form.mobile_no} onChange={(e)=>setForm({...form,mobile_no:e.target.value})}/>
              <input style={input} placeholder="Password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})}/>
              <input style={input} placeholder="Address" value={form.address} onChange={(e)=>setForm({...form,address:e.target.value})}/>

              <select style={input} value={form.role} onChange={(e)=>setForm({...form,role:e.target.value})}>
                <option value="">Select Role</option>
                <option value="sitemaster">Site Master</option>
                <option value="reviewer">Reviewer</option>
              </select>

              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                <button style={btn} onClick={handleSubmit}>Submit</button>
                <button style={cancelBtn} onClick={()=>{setShowForm(false);setEditId(null);}}>Cancel</button>
              </div>
            </div>
          </div>
        )}

 
        {showDelete && (
          <div style={overlay}>
            <div style={modal}>
              <h3>Confirm Delete</h3>
              <p>Are you sure you want to delete this staff?</p>

              <div style={{ display: "flex", gap: "10px" }}>
                <button style={btn} onClick={confirmDelete}>
                  Yes Delete
                </button>

                <button
                  style={cancelBtn}
                  onClick={() => {
                    setShowDelete(false);
                    setDeleteId(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Manageprojects;


const container = {
  background: "#fff",
  borderRadius: "10px",
  padding: "15px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  width: "100%",
};

const topBar = {
  display: "flex",
  flexWrap: "wrap",         
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
  marginBottom: "15px",
};

const searchInput = {
  padding: "8px 12px",
  borderRadius: "6px",
  border: "1px solid #ddd",
  flex: "1",
  minWidth: "120px",   
};

const addBtn = {
  background: "#D4C2BB",
  color: "#7D4B3C",
  border: "none",
  padding: "8px 15px",
  borderRadius: "6px",
  cursor: "pointer",
  whiteSpace: "nowrap",   
};

const tableWrapper = {
  width: "100%",
  overflowX: "auto",
};

const table = {
  width: "100%",
  borderCollapse: "collapse",
  minWidth: "650px",
};

const th = {
  textAlign: "left",
  padding: "12px",
  fontSize: "14px",
  color: "#555",
};

const tr = {
  borderBottom: "1px solid #eee",
};

const td = {
  padding: "10px",
  fontSize: "13px",
};

const editBtn = {
  padding: "6px",
  borderRadius: "6px",
  background: "#eef2ff",
  cursor: "pointer",
};

const deleteBtn = {
  padding: "6px",
  borderRadius: "6px",
  background: "#ffecec",
  cursor: "pointer",
  color: "#dc3545",
};

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modal = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "90%",
  maxWidth: "400px",
};

const input = {
  width: "100%",
  padding: "10px",
  marginBottom: "10px",
  border: "1px solid #ddd",
  borderRadius: "6px",
};

const btn = {
  background: "#D4C2BB",
  color: "#7D4B3C",
  padding: "8px 15px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const cancelBtn = {
  background: "#ccc",
  border: "none",
  padding: "8px 15px",
  borderRadius: "6px",
  cursor: "pointer",
};

const avatar = {
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  background: "#D4C2BB",
  color: "#7D4B3C",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
};

